import React, { Component } from 'react';
import { Notification } from 'react-admin';

class MyNotification extends Component {
    render() {
        const { props } = this;
        return (
            <Notification {...props} autoHideDuration={5000} />
        );
    }
}

export default MyNotification;